import React, {useEffect, useState} from 'react';
import {PcProfileSummary} from './pc/PcProfileSummary'; // 注意这里是默认导入
import {MobileProfileSummary} from './mobile/MobileProfileSummary'; // 注意这里是默认导入

function ProfileSummary({isMobile, clicked, data, clickNext, ...props}) { // 接收 isMobile props
    // 确保 clickNext 和 clickPrev props 被传递，如果未提供则使用空函数作为默认值


    const [bmi, setBmi] = useState(21);
    useEffect(() => {
        const curWeightKG = data?.currentWeight.getWeightWithUnitKG();
        const curHeight = data?.height.getHeightWithUnitM();
        if (curWeightKG && curHeight) {
            const bmiValue = curWeightKG / (curHeight * curHeight);
            setBmi(bmiValue.toFixed(1));
        } else {
            setBmi(0);
        }
    }, [data])
    useEffect(() => {
        if (clicked) {
            clickNext("");
        }
    }, [clicked]);
    const returnStyle = () => {
        let value = bmi;
        if (bmi < 18) {
            value = 18;
        } else if (bmi > 35) {
            value = 35;
        }
        const left = (value - 18) / (35 - 18);
        let color = "rgb(107, 214, 0)";
        if (left > 0.4) {
            color = "rgb(255, 215, 7)";
        } else if (color > 0.8) {
            color = "rgb(255, 92, 0)";
        }

        return {left: `calc((100% - 50px) * ${left} - 30px)`, color};
    }
    const {left, color} = returnStyle();
    const commonProps = {
        ...props,
        clicked,
        data,
        bmi,
        left,
        clickNext: clickNext || (() => {}),
        clickPrev: props.clickPrev || (() => {})
    };

    if (isMobile) { // 根据 isMobile props 条件渲染
        return <MobileProfileSummary {...commonProps} />;
    } else {
        return <PcProfileSummary {...commonProps} />;
    }
}

export default ProfileSummary;